import React from "../../__compat__/react/main.entry.mjs.mjs";
import { Layout, LayoutItem } from "../index.mjs.mjs";
import { SkeletonShape } from "../SkeletonShape/SkeletonShape.mjs.mjs";
import { containerHeight, containerWidth } from "./Toggle.styles.mjs.mjs";
export const ToggleSkeleton = (props) => {
    return (React.createElement(Layout, { direction: "row" },
        React.createElement(LayoutItem, null,
            React.createElement(SkeletonShape, { variant: "oval", width: `${containerWidth}px`, height: `${containerHeight}px` })),
        (props.hasChildren || props.hint) && (React.createElement(LayoutItem, { spaceInlineStart: "s", spaceStackStart: "xxs" },
            props.hasChildren && (React.createElement(SkeletonShape, { variant: "rectangular", height: "24px" })),
            props.hint && (React.createElement(SkeletonShape, { variant: "rectangular", height: "20px", spaceStackStart: "m" }))))));
};
//# sourceMappingURL=Toggle.skeleton.mjs.mjs.map